import React from 'react';

// 데이터 점무늬(꾸밈) — 2026-11-03 첫 화면 '20만+ 인스타그램 데이터 마이닝 경험' 카드 오른쪽 위.
// 글자 없음. 점이 대각선 물결로 차례로 밝아지고, 몇 개만 흰 점(나머지는 옅은 점). 움직임은 CSS 하나(sdl-dot, styles/animations.css)라 가볍다.
export const DataDotMatrix: React.FC<{ cols?: number; rows?: number; className?: string }> = ({ cols = 14, rows = 8, className = '' }) => {
    const dots: [number, number][] = [];
    for (let y = 0; y < rows; y++) for (let x = 0; x < cols; x++) dots.push([x, y]);
    return (
        <div
            aria-hidden
            className={`pointer-events-none grid gap-[11px] ${className}`}
            style={{
                gridTemplateColumns: `repeat(${cols}, 4px)`,
                maskImage: 'radial-gradient(closest-side at 70% 35%, #000 30%, transparent 100%)',
                WebkitMaskImage: 'radial-gradient(closest-side at 70% 35%, #000 30%, transparent 100%)',
            }}
        >
            {dots.map(([x, y]) => {
                const bright = (x * 7 + y * 13) % 11 === 0;
                return (
                    <span
                        key={`${x}-${y}`}
                        className="sdl-dot h-1 w-1 rounded-full"
                        style={{ background: bright ? ['#3182F6', '#4C9AFF', '#4C9AFF', '#5B8CFF'][(x + y) % 4] : 'rgba(255,255,255,0.30)', animationDelay: `${((x + y) % 14) * 0.16}s` }}
                    />
                );
            })}
        </div>
    );
};

export default DataDotMatrix;
